import React from "react";
import { Helmet } from "react-helmet";

const SEO = ({ 
  title = "Snapseed QR Codes", 
  description = "Download free Snapseed QR code presets for professional-quality photo edits.", 
  url = "https://www.snapseedqrcodes.download/", 
  image = "https://www.snapseedqrcodes.download/snapseedqrcodes_logo.webp", 
  schemaMarkup 
}) => {
  return (
    <Helmet>
      {/* Primary Meta Tags */}
      <title>{title}</title>
      <meta name="description" content={description} />
      <meta name="robots" content="index, follow" />
      <link rel="canonical" href={url} />

      {/* Open Graph / Facebook */}
      <meta property="og:type" content="website" />
      <meta property="og:title" content={title} />
      <meta property="og:description" content={description} />
      <meta property="og:image" content={image} />
      <meta property="og:url" content={url} />
      <meta property="og:site_name" content="Snapseed QR Codes" />

      {/* Twitter */}
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content={image} />
      <meta name="twitter:creator" content="@snapseedqrcodes" />
      <meta name="twitter:site" content="@snapseedqrcodes" />

      {/* Structured Data (JSON-LD) */}
      {schemaMarkup && (
        <script type="application/ld+json">
          {JSON.stringify(schemaMarkup)}
        </script>
      )}
    </Helmet>
  );
};

export default SEO;
